export function formatAccountAge(dateString) {
  const createdDate = new Date(dateString);
  const now = new Date();

  let years = now.getFullYear() - createdDate.getFullYear();
  let months = now.getMonth() - createdDate.getMonth();
  let days = now.getDate() - createdDate.getDate();

  if (days < 0) {
    months -= 1;
    const prevMonth = new Date(now.getFullYear(), now.getMonth(), 0);
    days += prevMonth.getDate();
  }

  if (months < 0) {
    years -= 1;
    months += 12;
  }

  // Formatting output conditions
  if (years === 0 && months === 0) {
    return `${days} days`;
  } else if (years === 0) {
    return `${months} months, ${days} days`;
  } else {
    return `${years} years, ${months} months, ${days} days`;
  }
}
